import React, { useState } from 'react'

import Typography from 'components/atoms/Typography'
import FAQ from 'components/molecules/FAQ'
import { Container, ListGroup } from 'components/qstrap'

import { faq as faqData } from './data'

const FAQs = () => {
  const [faqs, setFaqs] = useState(
    faqData.map(faq => ({ ...faq, active: false }))
  )

  const toggleAnswer = (id) => {
    const newFaqs = faqs.map(faq => (
        faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }
      )
    )
    setFaqs(newFaqs)
  }

  return (
    <div id="kit-faq" className="kit-faq">
      <Container>
        <Typography component="h2" variant="title" className="kit-faq__title text-center">
          Frequently Asked Questions
        </Typography>
        <ListGroup className="kit-faq__list">
          {
            faqs.map(faq => (
              <FAQ
                question={faq.question}
                answer={faq.answer}
                active={faq.active}
                key={`faq-itm-${faq.id}`}
                onClick={() => toggleAnswer(faq.id)}
              />
            ))
          }
        </ListGroup>
      </Container>
    </div>
  )
}

export default FAQs
